import { ValidationError, RequestError, SearchError } from '@/services/errorHandler.service'
import BackendApi from '@/services/backend.service'
import CustomException from '@/services/customException'

//falta declarar este modulo????
const state = {
  isUploadingFile: null,
  isExpandMultimediaMessageDialog: false,
  uploadedFile: null,
  uploadedFiles: [],
  isDownloadingFile: false,
  isFetchingQuickReplies: false,
  quickReplies: [],
  flows: [],
  selectedFlow: {},
  isFetchingFlows: false,
  isExpandFlowMessageDialog: false,
}

const getters = {}

const mutations = {
  SET_IS_UPLOADING_FILE(state, payload) {
    state.isUploadingFile = payload
  },
  SET_IS_EXPAND_MULTIMEDIA_MESSAGE_DIALOG(state, payload) {
    state.isExpandMultimediaMessageDialog = payload
  },
  SET_UPLOADED_FILE(state, payload) {
    state.uploadedFile = payload
  },
  SET_UPLOADED_FILES(state, payload) {
    state.uploadedFiles = payload
  },
  SET_IS_DOWNLOADING_FILE(state, payload) {
    state.isDownloadingFile = payload
  },
  SET_IS_FETCHING_QUICK_REPLIES(state, payload) {
    state.isFetchingQuickReplies = payload
  },
  SET_QUICK_REPLIES(state, payload) {
    state.quickReplies = payload
  },
  SET_FLOWS(state, payload) {
    state.flows = payload
  },
  SET_SELECTED_FLOW(state, payload) {
    state.selectedFlow = payload
  },
  SET_IS_FETCHING_FLOWS(state, payload) {
    state.isFetchingFlows = payload
  },
  SET_IS_EXPAND_FLOW_MESSAGE_DIALOG(state, payload) {
    state.isExpandFlowMessageDialog = payload
  },
}

const actions = {
  async getQuickReplies({ commit, rootState }, vueContext) {
    commit('SET_IS_FETCHING_QUICK_REPLIES', true)
    try {
      const workgroup_id = rootState.ticketsDrawer.workgroupAgent.workgroup_id
      const agent_id = rootState.ticketsDrawer.workgroupAgent.agent_id      
      const response = await BackendApi.get('/chat/quick_replies', {
        params: { workgroup_id, agent_id }
      })

      if (!response?.data?.success || !response?.data?.data) { 
        throw new RequestError(response)
      }
  
      commit('SET_QUICK_REPLIES', response.data.data)
    } catch (error) {
      CustomException.handleError({ error }, vueContext)
    } finally {
      commit('SET_IS_FETCHING_QUICK_REPLIES', false)
    }
  },
  async getFlows({ commit, rootState }, vueContext) {
    commit('SET_IS_FETCHING_FLOWS', true)
    try {
      const response = await BackendApi.get('/meta/whatsapp/flows')

      if (!response?.data?.success || !response?.data?.data) {
        throw new RequestError(response)
      }

      commit('SET_FLOWS', response.data.data)
    } catch (error) {
      CustomException.handleError({ rootMethod: 'getFlows', error }, vueContext)
    } finally {
      commit('SET_IS_FETCHING_FLOWS', false)
    }
  },
  
  async uploadFile({ commit }, file) {
    commit('SET_IS_UPLOADING_FILE', true)

    try {
      const formData = new FormData()

      formData.append('file', file)
      formData.append('name', file.name)
      
      const response = await BackendApi.post('/uploadFile', formData)

      commit('SET_IS_UPLOADING_FILE', false)

      return response
    } catch (error) {
      commit('SET_IS_UPLOADING_FILE', false)
      console.error(error)

      return false
    }
  },
  async uploadAndPreviewFile({ commit, dispatch }, { file, type, initialCaption, vueContext }) {
    commit('SET_IS_EXPAND_MULTIMEDIA_MESSAGE_DIALOG', true)
    try {      
      const response = await dispatch('uploadFile', file)

      if (!response || !response.data || !response.data.data ) {
        throw new ValidationError('Error del backend, no se encontró respuesta', { response })  
      }
      const uploadedFile = response.data.data

      if (!uploadedFile) {
        throw new ValidationError('No se ha logrado recuperar el arhchivo subido', { file, formData, uploadedFile })
      }

      if (type === 'visualMedia') {
        uploadedFile.type = file.type === 'video/mp4' ? 'video' : 'image'
      } else if (type === 'file') {
        uploadedFile.type = type 
      } else {
        throw new ValidationError('No se ha proporcionado el type', { type })
      }

      uploadedFile.originalCaption = initialCaption ?? ''
      commit('SET_UPLOADED_FILE', uploadedFile)
      if (type === 'visualMedia') {
        commit('SET_UPLOADED_FILES', [uploadedFile])
      }
    } catch (error) {
      CustomException.handleError({ error }, vueContext)
    }
  },
  async uploadAndPreviewFiles({ commit, dispatch }, { files, type, initialCaption, vueContext }) {
    if (!files || files.length === 0) return
    if (type !== 'visualMedia') return
    commit('SET_IS_UPLOADING_FILE', true)
    try {
      const uploaded = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const response = await dispatch('uploadFile', file)
        if (!response || !response.data || !response.data.data) {
          throw new ValidationError('Error del backend, no se encontró respuesta', { response })
        }
        const item = response.data.data
        if (!item) {
          throw new ValidationError('No se ha logrado recuperar el archivo subido', { file, item })
        }
        item.type = file.type === 'video/mp4' ? 'video' : 'image'
        if (i === 0) item.originalCaption = initialCaption ?? ''
        uploaded.push(item)
      }
      commit('SET_UPLOADED_FILES', uploaded)
      commit('SET_IS_EXPAND_MULTIMEDIA_MESSAGE_DIALOG', true)
    } catch (error) {
      CustomException.handleError({ error }, vueContext)
    } finally {
      commit('SET_IS_UPLOADING_FILE', false)
    }
  },
  async downloadFile({ commit }, url) {
    commit('SET_IS_DOWNLOADING_FILE', true)

    try {
      const response = await BackendApi.post('/chat/convert_image_to_base_64', { url })

      if (response?.data) {
        const responseContentType = response.headers?.['content-type'] || response.headers?.['Content-Type'] || 'image/jpeg'
        const cleanContentType = responseContentType.split(';')[0]
        const extensionByMimeType = {
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/png': 'png',
          'image/webp': 'webp',
          'image/gif': 'gif',
          'image/bmp': 'bmp',
          'image/svg+xml': 'svg'
        }
        const fileExtension = extensionByMimeType[cleanContentType] || 'jpg'
        const fileName = `img_${Date.now()}.${fileExtension}`

        const rawData = typeof response.data === 'string' ? response.data : ''
        const base64Content = rawData.includes('base64,') ? rawData.split('base64,')[1] : rawData
        const binary = atob(base64Content)
        const bytes = new Uint8Array(binary.length)

        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i)
        }

        const blob = new Blob([bytes], { type: cleanContentType })
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = blobUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      }
    } catch (error) {
      CustomException.handleError({ error })
    } finally {
      commit('SET_IS_DOWNLOADING_FILE', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}